export default {
    version: 0,
    completeEventsExpiryDays: 0,
    expiryDays: 0,
}
